import { Navigate, RouteObject, createBrowserRouter } from "react-router-dom";
import App from "../layout/App";
import LoginPage from "../../features/users/LoginPage";
import RequireAuth from "./RequireAuth";
import TestErrors from "../../features/errors/TestError";
import NotFound from "../../features/errors/NotFound";
import ServerError from "../../features/errors/ServerError";
import GroupFormPage from "../../features/group/GroupFormPage";
import SettingsPage from "../../features/settings/SettingsPage";
import AccountPage from "../../features/users/AccountPage";
import Dashboard from "../../features/home/Dashboard";
import ExitIframe from "./ExitIframe";
import ProductsPage from "../../features/products/ProductsPage";
import VehiclesPage from "../../features/vehicles/VehiclePage";
import VehicleFormPage from "../../features/vehicles/VehicleFormPage";
import ImportsPage from "../../features/imports/ImportsPage";
import ImportHistoryPage from "../../features/imports/ImportHistoryPage";
import ProductDetailsPage from "../../features/products/ProductDetailsPage";
import AdminPage from "../../features/admin/AdminPage";
import AdminStoresPage from "../../features/admin/AdminStoresPage";
import AdminStoreDetailsPage from "../../features/admin/AdminStoreDetailsPage";
import AdminSyncLogsPage from "../../features/admin/AdminSyncLogsPage";
import AdminSyncLogErrorsPage from "../../features/admin/AdminSyncLogErrorsPage";
import AdminErrorLogsPage from "../../features/admin/AdminErrorLogsPage";
import AdminWebhookLogsPage from "../../features/admin/AdminWebhookLogsPage";
import AdminDataFeedLogsPage from "../../features/admin/AdminDataFeedLogsPage";
import AdminFitmentImportLogsPage from "../../features/admin/AdminFitmentImportLogsPage";
import AdminSystemPage from "../../features/admin/AdminSystemPage";
import PreviewPage from "../../features/preview/PreviewPage";

export const routes: RouteObject[] = [
    {
        path: '/',
        element: <App />,
        children: [
            {element: <RequireAuth />, children: [  
                {path: '/', element: <Dashboard/> },              
                { path: 'dashboard', element: <Dashboard /> },
                { path: 'products', element: <ProductsPage /> },
                { path: 'products/:id', element: <ProductDetailsPage /> },
                { path: 'vehicles', element: <VehiclesPage /> },
                { path: 'createvehicle', element: <VehicleFormPage /> },
                {path: 'groups', element: <GroupFormPage />},
                {path: 'groups/:id', element: <GroupFormPage key='manage' />},
                {path: 'creategroup', element: <GroupFormPage key='create' />},
                {path: 'settings', element: <SettingsPage />},
                {path: 'imports', element: <ImportsPage />},
                {path: 'imports/history', element: <ImportHistoryPage />},
                {path: 'account', element: <AccountPage />},
                {path: 'errors', element: <TestErrors />}
            ]},
            // {path: 'not-found', element: <NotFound />},
            {path: 'login', element: <LoginPage />},
            {path: 'not-found', element: <NotFound />},
            {path: 'server-error', element: <ServerError />},
            {path: '*', element: <Navigate replace to='/not-found' />},
        ]
    },
    {
        path: '/exit-iframe',
        element: <ExitIframe />
    },
    {
        path: '/pf-console',
        element: <AdminPage />,
        children: [
            { path: 'stores', element: <AdminStoresPage /> },
            { path: 'stores/:shopId', element: <AdminStoreDetailsPage /> },
            { path: 'sync-logs', element: <AdminSyncLogsPage /> },
            { path: 'sync-logs/:syncLogId/errors', element: <AdminSyncLogErrorsPage /> },
            { path: 'error-logs', element: <AdminErrorLogsPage /> },
            { path: 'webhook-logs', element: <AdminWebhookLogsPage /> },
            { path: 'data-feed-logs', element: <AdminDataFeedLogsPage /> },
            { path: 'fitment-import-logs', element: <AdminFitmentImportLogsPage /> },
            { path: 'system', element: <AdminSystemPage /> }
        ]
    },
    {
        path: '/pf-preview',
        element: <PreviewPage />
    }
]

export const router = createBrowserRouter(routes);
